/*
 Auto-generated by generate-java-to-ts-maven-plugin. Do not edit.
 Source: de.mhus.vance.api.toolhealth.ToolErrorCode
*/
export var ToolErrorCode;
(function (ToolErrorCode) {
    ToolErrorCode["NOT_REGISTERED"] = "NOT_REGISTERED";
    ToolErrorCode["BACKEND_UNREACHABLE"] = "BACKEND_UNREACHABLE";
    ToolErrorCode["BACKEND_FAILED"] = "BACKEND_FAILED";
    ToolErrorCode["DISALLOWED"] = "DISALLOWED";
})(ToolErrorCode || (ToolErrorCode = {}));
//# sourceMappingURL=ToolErrorCode.js.map